import ConsoleApi from "@/consoleapi/consoleApi";
import {AxiosResponse} from "axios";

/**
 *
 */
export default class Statement extends ConsoleApi {
    protected readonly resource = '/statement';

    /**
     * @param accountId
     * @param year
     * @param month
     */
    public showMonthly(accountId: string, year: string, month: string,): Promise<AxiosResponse> {
        return this.axios.get(this.requestUri + this.getAccountResource(accountId) + '/monthly', {
            headers: {
                Authorization: `Bearer ${this.bearerToken}`,
            },
            params: {
                year: year,
                month: month
            }
        });
    }
}